const f = <T>(text: string): T | null => {
    try {
        return JSON.parse(text);
    } catch (e) {
        return null;
    }
};

export default f;
